
const LIB = 'soft-execution-context'

const INTERNAL_PROP = '_SEC'

export {
	LIB,
	INTERNAL_PROP,
}
